<div class="loading__veil">
  <ion-spinner
    class="loading__veil__spinner"
    [name]="name"
    color="primary"
  ></ion-spinner>
</div>
